export default "__VITE_ASSET__EHm6Httl__"